import axios from 'axios';

// axios reports an exceeded `timeout` as ECONNABORTED rather than ETIMEDOUT.
export const TIMEOUT_CODE = 'ECONNABORTED';

// Matched by shape: Next.js bundles `instrumentation.ts` apart from the render, so a
// `NetworkError` thrown during render fails `instanceof` against this module's class.
const isTimedOutNetworkError = (error: object): boolean =>
  (error as { name?: unknown }).name === 'NetworkError' &&
  (error as { isTimeout?: unknown }).isTimeout === true;

/**
 * Whether the error that ended a render was an API timeout. It reads the error rather than
 * request state, so a timeout the page recovered from isn't blamed for a later, unrelated crash.
 * It walks `cause` because a `NetworkError` is often re-wrapped on its way up.
 */
const isUpstreamTimeoutError = (error: unknown): boolean => {
  const seen = new Set<unknown>();
  let current: unknown = error;

  while (current !== null && typeof current === 'object' && !seen.has(current)) {
    seen.add(current);

    if (isTimedOutNetworkError(current)) {
      return true;
    }
    if (axios.isAxiosError(current) && current.code === TIMEOUT_CODE) {
      return true;
    }

    current = (current as { cause?: unknown }).cause;
  }

  return false;
};

export default isUpstreamTimeoutError;
